import { createSlice } from "@reduxjs/toolkit";

export const finOpsSlice = createSlice({
  name: "finOps",
  initialState: {
    isGettingFinOpsDashboard: false,
    getFinOpsDashboardMessage: null,
    getFinOpsDashboardError: null,
    finOpsDashboardData: null,
  },
  reducers: {
    getFinOpsDashboard: (state) => {
      state.isGettingFinOpsDashboard = true;
      state.getFinOpsDashboardMessage = null;
      state.getFinOpsDashboardError = null;
    },
    getFinOpsDashboardSuccessful: (state, action) => {
      state.isGettingFinOpsDashboard = false;
      state.getFinOpsDashboardMessage = action.payload?.message || action.payload?.data?.message || action.payload?.data || 'Success';
      state.getFinOpsDashboardError = null;
      const { status, ...dashboardData } = action.payload;
      state.finOpsDashboardData = dashboardData;
    },
    getFinOpsDashboardFailure: (state, action) => {
      state.isGettingFinOpsDashboard = false;
      state.getFinOpsDashboardMessage = null;
      state.getFinOpsDashboardError = action.payload.message;
    },
    clearFinOpsMessages: (state) => {
      state.getFinOpsDashboardMessage = null;
      state.getFinOpsDashboardError = null;
    },
  }
});

export const {
  getFinOpsDashboard,
  getFinOpsDashboardSuccessful,
  getFinOpsDashboardFailure,
  clearFinOpsMessages,
} = finOpsSlice.actions;

export default finOpsSlice.reducer;

